import _keyBy from 'lodash/keyBy'

import { CONFIG_ENABLE_EDD } from '@src/config/env'
import { STATSIG_EXPERIMENTS, STATSIG_EXPERIMENTS_CONFIG } from '@src/config/statsig-experiments.config'

import { EDDDetails, EDDProductType, VariantDetail } from '../../../services/eddService/eddService.types'
import { DAY_NAMES } from '../../../utils/constants'
import useEddExp from '../hooks/useEddExp'

const EDD_THRESHHOLD_DAYS = 5

export const getEDDDetails = (
  variantEDDDetails: number[] | undefined,
  eddDetails: EDDProductType | undefined,
  zipCode?: string,
  bucket?: string,
): EDDDetails => {
  if (
    !CONFIG_ENABLE_EDD ||
    bucket === STATSIG_EXPERIMENTS_CONFIG[STATSIG_EXPERIMENTS.EDD].buckets?.control ||
    !zipCode
  ) {
    return {
      showEDD: false,
      isExpressShipping: false,
    }
  }

  const isEDDGroupB = bucket === STATSIG_EXPERIMENTS_CONFIG[STATSIG_EXPERIMENTS.EDD].buckets?.groupB

  let standardDeliveryEDD: EDDDetails | null = null
  let expressDeliveryEDD: EDDDetails | null = null

  variantEDDDetails?.forEach?.(variantEDDDetail => {
    const eddDetail: VariantDetail | undefined = eddDetails?.[variantEDDDetail]

    if (eddDetail) {
      const eddDetailMap = _keyBy(eddDetail.delivery_types, 'type')
      const delivery = eddDetailMap.LB_STANDARD
      if (
        delivery &&
        delivery.max_days <= EDD_THRESHHOLD_DAYS &&
        (!standardDeliveryEDD || !standardDeliveryEDD.max_days || standardDeliveryEDD.max_days > delivery.max_days)
      ) {
        standardDeliveryEDD = {
          ...delivery,
          showEDD: true,
          isExpressShipping: false,
        }
      }

      if (isEDDGroupB) {
        const expressDelivery = eddDetailMap.LB_SUPER
        if (
          expressDelivery &&
          expressDelivery.max_days <= EDD_THRESHHOLD_DAYS &&
          (!expressDeliveryEDD ||
            !expressDeliveryEDD.max_days ||
            expressDeliveryEDD.max_days > expressDelivery.max_days)
        ) {
          expressDeliveryEDD = {
            ...expressDelivery,
            showEDD: true,
            isExpressShipping: true,
          }
        }
      }
    }
  })

  if (standardDeliveryEDD) return standardDeliveryEDD
  if (expressDeliveryEDD) return expressDeliveryEDD

  return {
    showEDD: false,
    isExpressShipping: false,
  }
}

export const useEDDDetailFromSelectedOptions = (
  eddDetails: EDDProductType | undefined,
  selectedOptionsVariantIds: number[] | undefined,
  zipCode?: string,
) => {
  const bucket = useEddExp()
  return getEDDDetails(selectedOptionsVariantIds, eddDetails, zipCode, bucket)
}

export const generateEDDLabel = (eddDetails: EDDDetails | undefined) => {
  if (!eddDetails?.max_date) return
  const date = new Date(eddDetails.max_date)
  const day = date.getDay()
  const month = date.getMonth() + 1
  const dayOfMonth = date.getDate().toString()
  return `Get it by ${DAY_NAMES[day]}, ${month}/${dayOfMonth.padStart(2, '0')}`
}
